import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BookOpen, Calendar, ShoppingBag, Activity, RefreshCcw, LayoutGrid, CheckCircle2, XCircle } from 'lucide-react';
export function DetailsSection() {
  return <section className="w-full px-6 py-16 md:py-20 bg-white" data-id="element-8">
      <div className="max-w-6xl mx-auto" data-id="element-9">
        {/* What You Get */}
        <div className="mb-20" data-id="element-10">
          <FadeIn data-id="element-11">
            <div className="text-center mb-10" data-id="element-12">
              <h2 className="text-4xl md:text-5xl mb-4 font-serif text-charcoal" data-id="element-13">
                Qué recibes
              </h2>
              <p className="text-rose italic font-serif text-2xl" data-id="element-14">
                (lo que viene adentro)
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-15">
              {[{
              icon: BookOpen,
              text: 'Guía PDF (50 págs) cero relleno'
            }, {
              icon: Calendar,
              text: 'Menú rotativo 7 días (micro/airfryer)'
            }, {
              icon: ShoppingBag,
              text: 'Lista de compras "cocina mínima"'
            }, {
              icon: Activity,
              text: 'Tracker 21 días (hinchazón, antojos, sueño)'
            }, {
              icon: RefreshCcw,
              text: 'Protocolo "me salí" → regreso en 24 horas'
            }, {
              icon: LayoutGrid,
              text: '20 combos 3‑2‑1 para mezclar y listo'
            }].map((item, i) => <div key={i} className="flex flex-col items-center text-center p-8 bg-blush/20 hover:bg-blush/40 transition-colors duration-300 border-b-2 border-rose/20" data-id="element-16">
                  <item.icon className="w-10 h-10 text-rose mb-6 stroke-[1.5]" data-id="element-17" />
                  <span className="font-medium text-charcoal text-lg font-serif italic" data-id="element-18">
                    {item.text}
                  </span>
                </div>)}
            </div>
          </FadeIn>
        </div>

        {/* Who is this for */}
        <div className="max-w-4xl mx-auto mb-20" data-id="element-19">
          <div className="grid md:grid-cols-2 bg-linen border border-charcoal/5" data-id="element-20">
            <FadeIn className="p-10 md:p-12 border-b md:border-b-0 md:border-r border-charcoal/5" data-id="element-21">
              <h3 className="text-2xl mb-8 flex items-center gap-3 font-serif italic text-charcoal" data-id="element-22">
                <CheckCircle2 className="text-gold w-6 h-6" data-id="element-23" />
                Es para ti si:
              </h3>
              <ul className="space-y-6" data-id="element-24">
                {['Estás cansada de empezar de cero', 'Tu problema grande ocurre en la noche', 'Quieres una estructura clara sin contar calorías', 'Quieres sentirte liviana y en control'].map((item, i) => <li key={i} className="flex items-start gap-4 text-body font-light" data-id="element-25">
                    <div className="w-1.5 h-1.5 rounded-full bg-gold mt-2.5 shrink-0" data-id="element-26" />
                    <span data-id="element-27">{item}</span>
                  </li>)}
              </ul>
            </FadeIn>

            <FadeIn delay={0.2} className="p-10 md:p-12 bg-charcoal/5" data-id="element-28">
              <h3 className="text-2xl mb-8 flex items-center gap-3 font-serif italic text-charcoal" data-id="element-29">
                <XCircle className="text-rose w-6 h-6" data-id="element-30" />
                No es para ti si:
              </h3>
              <ul className="space-y-6" data-id="element-31">
                {['Buscas un reto extremo o resultados "milagro"', 'Necesitas un plan clínico por condición médica', 'Estás en un TCA activo y necesitas acompañamiento'].map((item, i) => <li key={i} className="flex items-start gap-4 text-body font-light" data-id="element-32">
                    <div className="w-1.5 h-1.5 rounded-full bg-rose mt-2.5 shrink-0" data-id="element-33" />
                    <span data-id="element-34">{item}</span>
                  </li>)}
              </ul>
            </FadeIn>
          </div>
        </div>

        {/* Transformation */}
        <FadeIn data-id="element-35">
          <div className="bg-charcoal text-linen p-10 md:p-16 text-center relative overflow-hidden" data-id="element-36">
            <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-10" data-id="element-37"></div>

            <h2 className="text-4xl md:text-5xl text-white mb-8 font-serif relative z-10" data-id="element-38">
              Lo que cambia cuando funciona
            </h2>

            <div className="flex flex-col gap-6 max-w-2xl mx-auto mb-10 relative z-10" data-id="element-39">
              {['Dejas de vivir con miedo a las 9PM', 'Tu ropa deja de sentirse como castigo', 'Tu mente deja de negociar cada noche', 'Recuperas confianza en ti misma'].map((item, i) => <div key={i} className="border-b border-white/10 pb-6 last:border-0" data-id="element-40">
                  <p className="text-xl md:text-2xl font-light" data-id="element-41">{item}</p>
                </div>)}
            </div>

            <p className="text-xl md:text-2xl text-gold italic font-serif relative z-10 max-w-3xl mx-auto leading-relaxed" data-id="element-42">
              "No porque seas más disciplinada. Sino porque tu sistema ya no se
              rompe en tu momento más débil."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}